/**
 * @generated SignedSource<<cb064f2295850482dcbe48f4f95ad1d7>>
 * @relayHash 43b56c2b30e0b7d9703518b1b76737bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2fdf5ab43f9447405d9faa4eaef9488c28fcaa3d9e8361efa574596d4205087

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ServiceHubDetailsPageQuery } from './ServiceHubDetailsPageQuery.graphql';

const node: PreloadableConcreteRequest<ServiceHubDetailsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e2fdf5ab43f9447405d9faa4eaef9488c28fcaa3d9e8361efa574596d4205087",
    "metadata": {},
    "name": "ServiceHubDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
